module.exports = __webpack_public_path__ + "static/media/maintenance.b735d549.webp";